(function () {
  'use strict';

  if (window.pmcRatingBridgeLoaded) return;
  window.pmcRatingBridgeLoaded = true;

  var cache = new Map();
  var pendingItems = new WeakSet();
  var observedItems = new WeakSet();
  var observer;
  var scanTimer;

  function setAttributeIfChanged(element, name, value) {
    if (element.getAttribute(name) !== value) {
      element.setAttribute(name, value);
    }
  }

  var surfaceSelector = [
    '#product-grid',
    '.template-search__results',
    '.product-recommendations',
    '.predictive-search',
    '[class*="wiser"]',
    '[id*="wiser"]',
    '[data-wiser]',
    '[class*="frequently-bought"]',
    '[class*="frequently_bought"]',
    '[data-section-type*="recommend"]'
  ].join(',');

  function normaliseBadgeElement(badge, wrapper) {
    if (!badge) return false;

    wrapper = wrapper || badge.closest('[data-pmc-review-badge]');
    if (!wrapper && !badge.closest(surfaceSelector)) return false;

    var count = Number(badge.getAttribute('data-number-of-reviews') || 0);
    if (!isFinite(count) || count < 1) return false;

    var rating = Number(badge.getAttribute('data-average-rating') || 0);
    var countText = badge.querySelector('.jdgm-prev-badge__text');
    var stars = badge.querySelector('.jdgm-prev-badge__stars');

    if (!countText) {
      countText = document.createElement('span');
      countText.className = 'jdgm-prev-badge__text';

      if (stars && stars.parentNode) {
        stars.insertAdjacentElement('afterend', countText);
      } else {
        badge.appendChild(countText);
      }
    }

    var visibleCount = '(' + count + ')';
    if (countText.textContent.trim() !== visibleCount) {
      countText.textContent = visibleCount;
    }

    setAttributeIfChanged(countText, 'data-pmc-rating-count', String(count));
    setAttributeIfChanged(countText, 'aria-hidden', 'true');
    setAttributeIfChanged(countText, 'title', count + (count === 1 ? ' rating' : ' ratings'));

    var label = rating.toFixed(1) + ' out of 5 from ' + count + (count === 1 ? ' rating' : ' ratings');
    var accessibleBadge = wrapper || badge;
    setAttributeIfChanged(accessibleBadge, 'role', 'img');
    setAttributeIfChanged(accessibleBadge, 'aria-label', label);
    if (stars) {
      if (stars.hasAttribute('aria-label')) stars.removeAttribute('aria-label');
      setAttributeIfChanged(stars, 'aria-hidden', 'true');
    }
    setAttributeIfChanged(badge, 'data-pmc-rating-normalised', 'true');

    return true;
  }

  function normaliseBadges(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var badges = [];

    if (scope.matches && scope.matches('.jdgm-prev-badge[data-number-of-reviews]')) {
      badges.push(scope);
    }

    Array.prototype.push.apply(
      badges,
      scope.querySelectorAll('.jdgm-prev-badge[data-number-of-reviews]')
    );

    badges.forEach(function (badge) {
      normaliseBadgeElement(badge, badge.closest('[data-pmc-review-badge]'));
    });
  }

  function labelJudgeMeLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selector = 'a.jdgm-carousel-item__product';
    var links = [];

    if (scope.matches && scope.matches(selector)) links.push(scope);
    if (scope.closest) {
      var parentLink = scope.closest(selector);
      if (parentLink && links.indexOf(parentLink) === -1) links.push(parentLink);
    }
    Array.prototype.push.apply(links, scope.querySelectorAll(selector));

    links.forEach(function (link) {
      var titleNode = link.querySelector('.jdgm-carousel-item__product-title');
      var productTitle = titleNode ? (titleNode.textContent || '').replace(/\s+/g, ' ').trim() : '';

      if (!productTitle) {
        var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (match) {
          try {
            productTitle = decodeURIComponent(match[1]).replace(/[-_]+/g, ' ').trim();
          } catch (error) {
            productTitle = match[1].replace(/[-_]+/g, ' ').trim();
          }
        }
      }

      if (productTitle) {
        var linkLabel = 'View reviews for ' + productTitle;
        setAttributeIfChanged(link, 'aria-label', linkLabel);
      }
    });
  }

  function stopFeaturedCarouselAutoplay(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selector = '.jdgm-carousel__play-pause[aria-label]';
    var controls = [];

    if (scope.matches && scope.matches(selector)) controls.push(scope);
    Array.prototype.push.apply(controls, scope.querySelectorAll(selector));

    controls.forEach(function (control) {
      if (control.dataset.pmcAutoplayStopped === 'true') return;
      if (!/^pause reviews carousel$/i.test(control.getAttribute('aria-label') || '')) return;
      control.dataset.pmcAutoplayStopped = 'true';
      control.click();
    });
  }

  function normaliseBadgeHtml(html) {
    if (!html) return null;

    var template = document.createElement('template');
    template.innerHTML = String(html).trim();

    var wrapper = template.content.querySelector('[data-pmc-review-badge]');
    var badge = wrapper && wrapper.querySelector('.jdgm-prev-badge');

    if (!wrapper || !normaliseBadgeElement(badge, wrapper)) return null;

    return wrapper.outerHTML;
  }

  function hydrateSeed() {
    var seed = document.getElementById('pmc-rating-seed');
    if (!seed) return;

    try {
      var data = JSON.parse(seed.textContent || '{}');
      Object.keys(data).forEach(function (handle) {
        cache.set(handle, Promise.resolve(normaliseBadgeHtml(data[handle])));
      });
    } catch (error) {
      // The bridge falls back to product fragment requests.
    }
  }

  function getHandle(link) {
    if (!link || !link.href) return '';
    try {
      var url = new URL(link.href, window.location.origin);
      var match = url.pathname.match(/^\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function findSurface(link) {
    return link.closest(surfaceSelector);
  }

  function findItem(link, surface) {
    var nativeCard = link.closest('.card-wrapper');
    if (nativeCard) return nativeCard;

    var node = link;
    var fallback = link.parentElement;

    while (node && node !== surface && node !== document.body) {
      if (
        node.matches &&
        node.matches('li, article, [data-product-id], [data-product-handle], [class*="product-card"], [class*="product_card"], [class*="product-item"], [class*="product_item"], [class*="wiser-product"], [class*="wiser_product"], [class*="fbt-product"], [class*="fbt_product"]')
      ) {
        var productLinks = node.querySelectorAll('a[href*="/products/"]');
        if (productLinks.length === 1) return node;
        fallback = node;
      }
      node = node.parentElement;
    }

    return fallback || surface;
  }

  function findInsertTarget(item, link) {
    return (
      item.querySelector('.card-information__text') ||
      item.querySelector('.predictive-search__item-heading') ||
      item.querySelector('.wiser_product_title') ||
      item.querySelector('.wiser-product-title') ||
      item.querySelector('.fbt-product-title') ||
      item.querySelector('.fbt_product_title') ||
      item.querySelector('[class*="product-title"]') ||
      item.querySelector('[class*="product_title"]') ||
      item.querySelector('h3') ||
      item.querySelector('h4') ||
      link
    );
  }

  function fetchBadge(handle) {
    if (cache.has(handle)) return cache.get(handle);

    var request = fetch('/products/' + encodeURIComponent(handle) + '?view=pmc-rating', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Rating request failed');
        return response.text();
      })
      .then(normaliseBadgeHtml)
      .catch(function () {
        return null;
      });

    cache.set(handle, request);
    return request;
  }

  function loadItem(item) {
    if (!item || pendingItems.has(item) || item.dataset.pmcRatingLoaded === 'true') return;

    var link = item.querySelector('a[href*="/products/"]');
    var handle = getHandle(link);
    if (!handle) {
      item.dataset.pmcRatingLoaded = 'true';
      return;
    }

    pendingItems.add(item);

    fetchBadge(handle).then(function (html) {
      pendingItems.delete(item);
      item.dataset.pmcRatingLoaded = 'true';
      if (!html || item.querySelector('[data-pmc-review-badge]')) return;

      var target = findInsertTarget(item, link);
      if (!target || !target.parentNode) return;
      target.insertAdjacentHTML('afterend', html);
      normaliseBadges(item);
    });
  }

  function queueItem(item) {
    if (!item || observedItems.has(item) || item.dataset.pmcRatingLoaded === 'true') return;
    observedItems.add(item);

    if ('IntersectionObserver' in window) {
      if (!observer) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              loadItem(entry.target);
            });
          },
          { rootMargin: '350px 0px' }
        );
      }
      observer.observe(item);
    } else {
      loadItem(item);
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links = [];

    if (scope.matches && scope.matches('a[href*="/products/"]')) links.push(scope);
    Array.prototype.push.apply(links, scope.querySelectorAll('a[href*="/products/"]'));

    links.forEach(function (link) {
      var surface = findSurface(link);
      if (!surface) return;

      var item = findItem(link, surface);
      if (!item) return;

      queueItem(item);
    });
  }

  function scheduleScan(root) {
    window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(function () {
      normaliseBadges(root || document);
      scan(root || document);
    }, 90);
  }

  function start() {
    hydrateSeed();
    normaliseBadges(document);
    labelJudgeMeLinks(document);
    stopFeaturedCarouselAutoplay(document);
    scan(document);

    var mutationObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          stopFeaturedCarouselAutoplay(record.target);
          normaliseBadgeElement(
            record.target,
            record.target.closest('[data-pmc-review-badge]')
          );
          return;
        }

        Array.prototype.forEach.call(record.addedNodes || [], function (node) {
          if (node.nodeType !== 1) return;
          normaliseBadges(node);
          labelJudgeMeLinks(node);
          stopFeaturedCarouselAutoplay(node);
          scheduleScan(node);
        });
      });
    });

    mutationObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-average-rating', 'data-number-of-reviews'],
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      normaliseBadges(document);
      stopFeaturedCarouselAutoplay(document);
      scan(document);
    }, 700);
    window.setTimeout(function () {
      normaliseBadges(document);
      stopFeaturedCarouselAutoplay(document);
      scan(document);
    }, 1800);
    window.setTimeout(function () {
      normaliseBadges(document);
      stopFeaturedCarouselAutoplay(document);
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
